import React, { FC } from 'react';

interface ILogoProps {
	width?: number;
	height?: number;
	className?: string;
	style?: React.CSSProperties;
}

const Logo: FC<ILogoProps> = ({ 
	width, 
	height, 
	className = '', 
	style = {} 
}) => {
	// Default responsive behavior with proper aspect ratio
	const logoStyle: React.CSSProperties = {
		maxWidth: '100%',
		height: 'auto',
		objectFit: 'contain',
		display: 'block',
		...style,
	};

	// If specific dimensions are provided, use them
	if (width) {
		logoStyle.width = width;
	}
	if (height) {
		logoStyle.height = height;
	}

	// If no dimensions provided, use responsive defaults
	if (!width && !height) {
		logoStyle.maxHeight = '50px'; // Default max height for responsive behavior
		logoStyle.width = 'auto';
	}

	// Enhanced error handling with PNG fallback
	const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
		const target = e.currentTarget;
		
		if (target.src.includes('logo.png')) {
			// Final fallback: hide the image and show text
			console.error('Logo PNG failed to load, showing text fallback');
			target.style.display = 'none';
			
			// Create a text fallback
			const parent = target.parentElement;
			if (parent && !parent.querySelector('.logo-fallback-text')) {
				const textFallback = document.createElement('div');
				textFallback.className = 'logo-fallback-text';
				textFallback.style.fontSize = height ? `${height * 0.4}px` : '20px';
				textFallback.style.fontWeight = 'bold';
				textFallback.style.color = 'var(--bs-primary, #007bff)';
				textFallback.style.textAlign = 'center';
				textFallback.textContent = 'JGS Tech';
				parent.appendChild(textFallback);
			}
		}
	};

	return (
		<img
			src={`${process.env.PUBLIC_URL}/logo.png`}
			alt="JGS Tech Logo"
			className={`logo ${className}`}
			style={logoStyle}
			onError={handleImageError}
			loading="lazy"
			decoding="async"
		/>
	);
};

export default Logo;
